<script>

export default {
  name: 'ChannelPostMenu',
  props: {
    post: {type: Object, required: true},
    direct: {type: Boolean, default: false},
    likesOnly: {type: Boolean, default: false},
  },

  data() {
    return {
      userId: this.$storage.getUserUuid(),
    }
  },
}
</script>

<template>
    <span class="c-post-menu me-2">
        <button class="btn btn-outline-light btn-sm me-1" title="confirm"
         @click.prevent="$emit('thumbsup', post.id)">&#128077;
        </button>
        <button class="btn btn-outline-light btn-sm me-1" title="like"
         @click.prevent="$emit('like', post.id)">&#10084;&#65039;
        </button>
        <template v-if="!likesOnly">
          <button class="btn btn-outline-light btn-sm" title="reply"
          @click.prevent="$emit('reply', post.id)">
              <i class="fas fa-reply" style="color:grey"></i>
          </button>
          <button  v-if="userId != post.user_id && !direct"
          class="btn btn-outline-light btn-sm" title="reply private"
          @click.prevent="$emit('reply-private', post.id)">
              <i class="fas fa-user-lock" style="color:grey"></i>
          </button>
          <button v-if="userId == post.user_id"
          class="btn btn-outline-light btn-sm" title="edit"
          @click.prevent="$emit('edit', post.id)">
              <i class="fas fa-edit" style="color:grey"></i>
          </button>
          <button v-if="userId == post.user_id"
          class="btn btn-outline-light btn-sm" title="delete"
          @click.prevent="$emit('delete', post.id)">
              <i class="fas fa-trash" style="color:grey"></i>
          </button>
        </template>
    </span>
</template>

<style scoped>

.c-post-menu {
    position: absolute;
    right: 0;
    margin-top: -1rem;
    padding: .5rem;

    border: 1px solid lightgrey;
    border-radius:.25rem;
    background: white;
    z-index: 1000;
}

</style>